import * as i0 from '@angular/core';
import { InjectionToken, Injectable, forwardRef, Directive, EventEmitter, Component, Inject, ViewChild, Input, Output, PLATFORM_ID, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALIDATORS, UntypedFormControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i4 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i5 from '@angular/material/form-field';
import { animation, style, animate, trigger, transition, useAnimation, state, query, stagger, animateChild } from '@angular/animations';
import { distinctUntilChanged, debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i3 from '@angular/flex-layout/flex';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
const _c0 = ["search"];
function MatGoogleMapsAutocompleteComponent_mat_error_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.requiredErrorText, " ");
  }
}
function MatGoogleMapsAutocompleteComponent_mat_error_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.invalidErrorText, " ");
  }
}
const _c1 = ["inputField"];
const _c2 = () => ({
  y: "100%"
});
const _c3 = a0 => ({
  value: "*",
  params: a0
});
function MatSearchGoogleMapsAutocompleteComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "mat-form-field", 11)(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 15);
    i0.ɵɵlistener("onAutocompleteSelected", function MatSearchGoogleMapsAutocompleteComponent_div_1_Template_input_onAutocompleteSelected_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.syncAutoComplete($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-icon", 13);
    i0.ɵɵtext(6, "search");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("appearance", ctx_r1.searchBarAppearance)("@animate", i0.ɵɵpureFunction1(9, _c3, i0.ɵɵpureFunction0(8, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.searchAddressLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("country", ctx_r1.country)("placeIdOnly", ctx_r1.placeIdOnly)("strictBounds", ctx_r1.strictBounds)("types", ctx_r1.types)("type", ctx_r1.type);
  }
}
function MatSearchGoogleMapsAutocompleteComponent_mat_form_field_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("appearance", ctx_r1.appearance)("@animate", i0.ɵɵpureFunction1(5, _c3, i0.ɵɵpureFunction0(4, _c2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.vicinityLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("readonly", ctx_r1.readonly);
  }
}
function parseGermanAddress(placeResult) {
  const germanAddress = {
    gmID: placeResult.id,
    icon: placeResult.icon,
    url: placeResult.url,
    placeID: placeResult.place_id,
    displayAddress: placeResult.formatted_address,
    name: placeResult.name,
    vicinity: placeResult.vicinity,
    locality: {},
    state: {},
    country: {},
    geoLocation: {
      latitude: -1,
      longitude: -1
    }
  };
  if (placeResult.geometry && placeResult.geometry.location) {
    germanAddress.geoLocation.latitude = placeResult.geometry.location.lat();
    germanAddress.geoLocation.longitude = placeResult.geometry.location.lng();
  }
  if (placeResult.address_components && placeResult.address_components.length > 0) {
    placeResult.address_components.forEach(value => {
      if (value.types.indexOf('street_number') > -1) {
        germanAddress.streetNumber = value.short_name;
      }
      if (value.types.indexOf('route') > -1) {
        germanAddress.streetName = value.long_name;
      }
      if (value.types.indexOf('postal_code') > -1) {
        germanAddress.postalCode = Number(value.short_name);
      }
      if (value.types.indexOf('sublocality') > -1) {
        germanAddress.sublocality = value.long_name;
      }
      if (value.types.indexOf('locality') > -1) {
        germanAddress.locality.long = value.long_name;
        germanAddress.locality.short = value.short_name;
      }
      if (value.types.indexOf('administrative_area_level_1') > -1) {
        germanAddress.state.long = value.long_name;
        germanAddress.state.short = value.short_name;
      }
      if (value.types.indexOf('country') > -1) {
        germanAddress.country.long = value.long_name;
        germanAddress.country.short = value.short_name;
      }
      if (value.types.indexOf('administrative_area_level_3') > -1) {
        germanAddress.locality.short = value.short_name;
      }
    });
  }
  return germanAddress;
}
const ApiKeyToken = new InjectionToken('apiKey');
let ScriptLoaderService = /*#__PURE__*/(() => {
  class ScriptLoaderService {
    loadedScripts = {};
    scriptPromises = {}; // Neu
    loadScript(src) {
      // Wenn das Skript bereits erfolgreich geladen wurde, sofort auflösen
      if (this.loadedScripts[src]) {
        return Promise.resolve();
      }
      // Wenn ein Ladevorgang für dieses Skript bereits im Gange ist, das vorhandene Promise zurückgeben
      if (this.scriptPromises[src]) {
        return this.scriptPromises[src];
      }
      // Ein neues Promise für das Skript-Laden erstellen und speichern
      this.scriptPromises[src] = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true; // Empfohlen für externe Skripte
        script.onload = () => {
          this.loadedScripts[src] = true; // Markiere das Skript als geladen
          resolve();
        };
        script.onerror = error => {
          this.scriptPromises[src] = null; // Bei Fehler, entferne das Promise, damit erneute Versuche möglich sind
          reject(error);
        };
        document.body.appendChild(script);
      });
      return this.scriptPromises[src];
    }
    static ɵfac = function ScriptLoaderService_Factory(t) {
      return new (t || ScriptLoaderService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScriptLoaderService,
      factory: ScriptLoaderService.ɵfac,
      providedIn: 'root'
    });
  }
  return ScriptLoaderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// https://github.com/angular/angular/blob/master/packages/forms/src/directives/validators.ts
let MatValidateAddressDirective = /*#__PURE__*/(() => {
  class MatValidateAddressDirective {
    subscription;
    _address;
    constructor() {}
    validate() {
      return control => {
        return this.address ? null : {
          validateAddress: {
            valid: false
          }
        };
      };
    }
    subscribe(eventEmitter) {
      this.subscription = eventEmitter.subscribe(address => {
        this.address = address;
      });
    }
    unsubscribe() {
      this.subscription.unsubscribe();
    }
    get address() {
      return this._address;
    }
    set address(value) {
      this._address = value;
    }
    static ɵfac = function MatValidateAddressDirective_Factory(t) {
      return new (t || MatValidateAddressDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatValidateAddressDirective,
      selectors: [["", "mat-address-validate", "", "formControlName", ""], ["", "MatValidateAddress", "", "formControl", ""], ["", "MatValidateAddress", "", "ngModel", ""]],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => MatValidateAddressDirective),
        multi: true
      }])]
    });
  }
  return MatValidateAddressDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Appearance = /*#__PURE__*/function (Appearance) {
  Appearance["STANDARD"] = "standard";
  Appearance["FILL"] = "fill";
  Appearance["OUTLINE"] = "outline";
  Appearance["LEGACY"] = "legacy";
  return Appearance;
}(Appearance || {});
let MatGoogleMapsAutocompleteComponent = /*#__PURE__*/(() => {
  class MatGoogleMapsAutocompleteComponent {
    ngZone;
    apiKey;
    loaderService;
    autocomplete;
    searchElementRef;
    addressLabelText = 'Address';
    placeholderText = 'Please enter the address';
    requiredErrorText = 'The address is required';
    invalidErrorText = 'The address is not valid';
    appearance = Appearance.STANDARD;
    value;
    address;
    country;
    placeIdOnly;
    strictBounds;
    types;
    // types: string[] = ['address'];
    type;
    autoCompleteOptions = {};
    onChange = new EventEmitter();
    onAutocompleteSelected = new EventEmitter();
    onGermanAddressMapped = new EventEmitter();
    onLocationSelected = new EventEmitter();
    onNewPlaceResult = new EventEmitter();
    addressValidator = new MatValidateAddressDirective();
    addressSearchControl = new UntypedFormControl({
      value: null
    }, Validators.compose([Validators.required, this.addressValidator.validate()]));
    propagateChange = _ => {};
    constructor(ngZone, apiKey, loaderService) {
      this.ngZone = ngZone;
      this.apiKey = apiKey;
      this.loaderService = loaderService;
    }
    ngOnInit() {
      this.addressValidator.subscribe(this.onNewPlaceResult);
      const options = {
        // types: ['address'],
        // componentRestrictions: {country: this.country},
        placeIdOnly: this.placeIdOnly,
        strictBounds: this.strictBounds,
        // types: this.types,
        type: this.type
      };
      // tslint:disable-next-line:no-unused-expression
      this.country ? options.componentRestrictions = {
        country: this.country
      } : null;
      // tslint:disable-next-line:no-unused-expression
      this.country ? options.types = this.types : null;
      this.autoCompleteOptions = Object.assign(this.autoCompleteOptions, options);
      this.initGoogleMapsAutocomplete();
    }
    ngOnDestroy() {
      if (this.autocomplete) {
        google.maps.event.clearInstanceListeners(this.autocomplete);
      }
    }
    initGoogleMapsAutocomplete() {
      this.loaderService.loadScript(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`).then(() => {
        this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, this.autoCompleteOptions);
        this.autocomplete.addListener('place_changed', () => {
          this.ngZone.run(() => {
            // get the place result
            const place = this.autocomplete.getPlace();
            const germanAddress = {
              gmID: place.id,
              icon: place.icon,
              url: place.url,
              placeID: place.place_id,
              displayAddress: place.formatted_address,
              name: place.name,
              vicinity: place.vicinity,
              locality: {},
              state: {},
              country: {},
              geoLocation: {
                latitude: -1,
                longitude: -1
              }
            };
            if (place.geometry && place.geometry.location) {
              germanAddress.geoLocation.latitude = place.geometry.location.lat();
              germanAddress.geoLocation.longitude = place.geometry.location.lng();
            }
            if (place.address_components) {
              place.address_components.forEach(value => {
                if (value.types.indexOf('street_number') > -1) {
                  germanAddress.streetNumber = value.short_name;
                }
                if (value.types.indexOf('route') > -1) {
                  germanAddress.streetName = value.long_name;
                }
                if (value.types.indexOf('postal_code') > -1) {
                  germanAddress.postalCode = Number(value.short_name);
                }
                if (value.types.indexOf('sublocality') > -1) {
                  germanAddress.sublocality = value.long_name;
                }
                if (value.types.indexOf('locality') > -1) {
                  germanAddress.locality.long = value.long_name;
                  germanAddress.locality.short = value.short_name;
                }
                if (value.types.indexOf('administrative_area_level_1') > -1) {
                  germanAddress.state.long = value.long_name;
                  germanAddress.state.short = value.short_name;
                }
                if (value.types.indexOf('country') > -1) {
                  germanAddress.country.long = value.long_name;
                  germanAddress.country.short = value.short_name;
                }
                if (value.types.indexOf('administrative_area_level_3') > -1) {
                  germanAddress.locality.short = value.short_name;
                }
              });
            }
            this.onGermanAddressMapped.emit(germanAddress);
            if (!place.place_id || place.geometry === undefined || place.geometry === null) {
              // place result is not valid
              return;
            } else {
              // show dialog to select a address from the input
              // emit failed event
              this.value = place;
              this.propagateChange(this.value);
            }
            this.address = place.formatted_address;
            this.onAutocompleteSelected.emit(place);
            this.onLocationSelected.emit({
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng()
            });
          });
        });
      }).catch(err => console.log(err));
    }
    onQuery(event) {
      this.onChange.emit(this.address);
    }
    resetAddress() {
      this.address = null;
      this.addressSearchControl.updateValueAndValidity();
    }
    writeValue(obj) {
      if (obj) {
        this.value = obj;
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {
      throw new Error('Method not implemented.');
    }
    setDisabledState(isDisabled) {
      throw new Error('Method not implemented.');
    }
    static ɵfac = function MatGoogleMapsAutocompleteComponent_Factory(t) {
      return new (t || MatGoogleMapsAutocompleteComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(ApiKeyToken), i0.ɵɵdirectiveInject(ScriptLoaderService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatGoogleMapsAutocompleteComponent,
      selectors: [["mat-google-maps-autocomplete"]],
      viewQuery: function MatGoogleMapsAutocompleteComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchElementRef = _t.first);
        }
      },
      inputs: {
        addressLabelText: "addressLabelText",
        placeholderText: "placeholderText",
        requiredErrorText: "requiredErrorText",
        invalidErrorText: "invalidErrorText",
        appearance: "appearance",
        value: "value",
        address: "address",
        country: "country",
        placeIdOnly: "placeIdOnly",
        strictBounds: "strictBounds",
        types: "types",
        type: "type",
        autoCompleteOptions: "autoCompleteOptions"
      },
      outputs: {
        onChange: "onChange",
        onAutocompleteSelected: "onAutocompleteSelected",
        onGermanAddressMapped: "onGermanAddressMapped",
        onLocationSelected: "onLocationSelected"
      },
      exportAs: ["matGoogleMapsAutocomplete"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MatGoogleMapsAutocompleteComponent),
        multi: true
      }])],
      decls: 7,
      vars: 6,
      consts: [["search", ""], [1, "full-width", 3, "appearance"], ["matInput", "", "MatValidateAddress", "", "required", "", 1, "form-control", 3, "ngModelChange", "change", "ngModel", "placeholder"], [4, "ngIf"]],
      template: function MatGoogleMapsAutocompleteComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "mat-form-field", 1)(1, "mat-label");
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "input", 2, 0);
          i0.ɵɵtwoWayListener("ngModelChange", function MatGoogleMapsAutocompleteComponent_Template_input_ngModelChange_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.address, $event) || (ctx.address = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("change", function MatGoogleMapsAutocompleteComponent_Template_input_change_3_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onQuery($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, MatGoogleMapsAutocompleteComponent_mat_error_5_Template, 2, 1, "mat-error", 3)(6, MatGoogleMapsAutocompleteComponent_mat_error_6_Template, 2, 1, "mat-error", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("appearance", ctx.appearance);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.addressLabelText);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholderText);
          i0.ɵɵtwoWayProperty("ngModel", ctx.address);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.addressSearchControl.hasError("required"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.addressSearchControl.hasError("validateAddress"));
        }
      },
      dependencies: [i2.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.RequiredValidator, i1.NgModel, i4.MatInput, i5.MatFormField, i5.MatLabel, i5.MatError, MatValidateAddressDirective],
      styles: [".full-width[_ngcontent-%COMP%]{width:100%}"]
    });
  }
  return MatGoogleMapsAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const customAnimation = animation([style({
  opacity: '{{opacity}}',
  transform: 'scale({{scale}}) translate3d({{x}}, {{y}}, {{z}})'
}), animate('{{duration}} {{delay}} cubic-bezier(0.0, 0.0, 0.2, 1)', style('*'))], {
  params: {
    duration: '200ms',
    delay: '0ms',
    opacity: '0',
    scale: '1',
    x: '0',
    y: '0',
    z: '0'
  }
});
const InputAnimations = [trigger('animate', [transition('void => *', [useAnimation(customAnimation)])]), trigger('animateStagger', [state('50', style('*')), state('100', style('*')), state('200', style('*')), transition('void => 50', query('@*', [stagger('50ms', [animateChild()])], {
  optional: true
})), transition('void => 100', query('@*', [stagger('100ms', [animateChild()])], {
  optional: true
})), transition('void => 200', query('@*', [stagger('200ms', [animateChild()])], {
  optional: true
}))])];
let MatGoogleMapsAutocompleteDirective = /*#__PURE__*/(() => {
  class MatGoogleMapsAutocompleteDirective {
    platformId;
    apiKey;
    elemRef;
    cf;
    loaderService;
    ngZone;
    inputField;
    autocomplete;
    address;
    country;
    placeIdOnly;
    strictBounds;
    types;
    type;
    autoCompleteOptions = {};
    onChange = new EventEmitter();
    onAutocompleteSelected = new EventEmitter();
    onGermanAddressMapped = new EventEmitter();
    onLocationSelected = new EventEmitter();
    disabled;
    _value;
    get value() {
      return this._value;
    }
    set value(value) {
      this._value = value;
      this.propagateChange(this.value);
      this.cf.markForCheck();
    }
    onNewPlaceResult = new EventEmitter();
    propagateChange = _ => {};
    constructor(platformId, apiKey, elemRef, cf, loaderService, ngZone) {
      this.platformId = platformId;
      this.apiKey = apiKey;
      this.elemRef = elemRef;
      this.cf = cf;
      this.loaderService = loaderService;
      this.ngZone = ngZone;
    }
    ngOnDestroy() {
      if (this.autocomplete) {
        google.maps.event.clearInstanceListeners(this.autocomplete);
      }
    }
    ngAfterViewInit() {
      this.loadMap();
    }
    ngOnInit() {}
    validate(fc) {
      return fc.hasValidator(Validators.required) ? !!fc?.value : true;
    }
    onChangeInputValue() {
      const value = this.elemRef.nativeElement?.value;
      this.value = value;
    }
    initGoogleMapsAutocomplete() {
      const autocomplete = new google.maps.places.Autocomplete(this.elemRef.nativeElement, this.autoCompleteOptions);
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place = autocomplete.getPlace();
          const germanAddress = {
            gmID: place.id,
            icon: place.icon,
            url: place.url,
            placeID: place.place_id,
            displayAddress: place.formatted_address,
            name: place.name,
            vicinity: place.vicinity,
            locality: {},
            state: {},
            country: {},
            geoLocation: {
              latitude: -1,
              longitude: -1
            }
          };
          if (place.geometry && place.geometry.location) {
            germanAddress.geoLocation.latitude = place.geometry.location.lat();
            germanAddress.geoLocation.longitude = place.geometry.location.lng();
          }
          place.address_components.forEach(value => {
            if (value.types.indexOf('street_number') > -1) {
              germanAddress.streetNumber = value.short_name;
            }
            if (value.types.indexOf('route') > -1) {
              germanAddress.streetName = value.long_name;
            }
            if (value.types.indexOf('postal_code') > -1) {
              germanAddress.postalCode = Number(value.short_name);
            }
            if (value.types.indexOf('sublocality') > -1) {
              germanAddress.sublocality = value.long_name;
            }
            if (value.types.indexOf('locality') > -1) {
              germanAddress.locality.long = value.long_name;
              germanAddress.locality.short = value.short_name;
            }
            if (value.types.indexOf('administrative_area_level_1') > -1) {
              germanAddress.state.long = value.long_name;
              germanAddress.state.short = value.short_name;
            }
            if (value.types.indexOf('country') > -1) {
              germanAddress.country.long = value.long_name;
              germanAddress.country.short = value.short_name;
            }
            if (value.types.indexOf('administrative_area_level_3') > -1) {
              germanAddress.locality.short = value.short_name;
            }
          });
          this.onGermanAddressMapped.emit(germanAddress);
          this.value = place.formatted_address;
          this.address = place.formatted_address;
          this.onAutocompleteSelected.emit(place);
          this.onLocationSelected.emit({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng()
          });
        });
      });
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    writeValue(obj) {
      if (obj) {
        this.value = obj;
      }
    }
    loadMap() {
      this.loaderService.loadScript(`https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`).then(() => {
        this.initMap();
      }).catch(error => console.error('Google Maps loading failed: ', error));
    }
    initMap() {
      if (isPlatformBrowser(this.platformId)) {
        console.log("on after view init --> ", this.elemRef.nativeElement);
        this.autocomplete = new google.maps.places.Autocomplete(this.elemRef.nativeElement);
        const options = {
          // types: ['address'],
          // componentRestrictions: {country: this.country},
          placeIdOnly: this.placeIdOnly,
          strictBounds: this.strictBounds,
          // types: this.types,
          type: this.type
        };
        // tslint:disable-next-line:no-unused-expression
        this.country ? options.componentRestrictions = {
          country: this.country
        } : null;
        // tslint:disable-next-line:no-unused-expression
        this.country ? options.types = this.types : null;
        this.autoCompleteOptions = Object.assign(this.autoCompleteOptions, options);
        this.initGoogleMapsAutocomplete();
      }
    }
    static ɵfac = function MatGoogleMapsAutocompleteDirective_Factory(t) {
      return new (t || MatGoogleMapsAutocompleteDirective)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(ApiKeyToken), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ScriptLoaderService), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatGoogleMapsAutocompleteDirective,
      selectors: [["", "matGoogleMapsAutocomplete", ""]],
      viewQuery: function MatGoogleMapsAutocompleteDirective_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputField = _t.first);
        }
      },
      hostBindings: function MatGoogleMapsAutocompleteDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("change", function MatGoogleMapsAutocompleteDirective_change_HostBindingHandler() {
            return ctx.onChangeInputValue();
          });
        }
      },
      inputs: {
        address: "address",
        country: "country",
        placeIdOnly: "placeIdOnly",
        strictBounds: "strictBounds",
        types: "types",
        type: "type",
        autoCompleteOptions: "autoCompleteOptions",
        value: "value"
      },
      outputs: {
        onChange: "onChange",
        onAutocompleteSelected: "onAutocompleteSelected",
        onGermanAddressMapped: "onGermanAddressMapped",
        onLocationSelected: "onLocationSelected"
      },
      exportAs: ["matGoogleMapsAutocomplete"],
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => MatGoogleMapsAutocompleteDirective),
        multi: true
      }])]
    });
  }
  return MatGoogleMapsAutocompleteDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatSearchGoogleMapsAutocompleteComponent = /*#__PURE__*/(() => {
  class MatSearchGoogleMapsAutocompleteComponent {
    formBuilder;
    constructor(formBuilder) {
      this.formBuilder = formBuilder;
      // Set the private defaults
      this._unsubscribeAll = new Subject();
    }
    searchBarAppearance;
    appearance = Appearance.STANDARD;
    searchAddressLabel = 'Search Address';
    streetNameLabel = 'Street';
    streetNumberLabel = 'Nr.';
    postalCodeLabel = 'PLZ';
    localityLabel = 'Locality';
    vicinityLabel = 'Vicinity';
    showVicinity;
    country;
    placeIdOnly;
    strictBounds;
    types;
    // types: string[] = ['address'];
    type;
    readonly;
    disableSearch;
    _value;
    onGermanAddressMapped = new EventEmitter();
    germanAddress;
    addressFormGroup;
    firstInit = true;
    // Private
    _unsubscribeAll;
    propagateChange = _ => {};
    get value() {
      return this._value;
    }
    set value(value) {
      this._value = value;
      this.propagateChange(this.value);
    }
    ngOnInit() {
      this.createAddressFormGroup();
      this.enableCustomInput();
    }
    createAddressFormGroup() {
      this.addressFormGroup = this.formBuilder.group({
        streetName: [this.value && this.value.streetName ? this.value.streetName : null, Validators.required],
        streetNumber: [this.value && this.value.streetNumber ? this.value.streetNumber : null, Validators.required],
        postalCode: [this.value && this.value.postalCode ? this.value.postalCode : null, Validators.required],
        vicinity: [this.value && this.value.vicinity ? this.value.vicinity : null],
        locality: this.formBuilder.group({
          long: [this.value && this.value.locality && this.value.locality.long ? this.value.locality.long : null, Validators.required]
        })
      });
    }
    enableCustomInput() {
      this.addressFormGroup.get('streetName').valueChanges.pipe(distinctUntilChanged(), debounceTime(400), takeUntil(this._unsubscribeAll)).subscribe(streetName => {
        !this.value ? this.value = {
          streetName
        } : this.value.streetName = streetName;
        this.value.displayAddress = this.parseDisplayAddress();
        this.propagateChange(this.value);
      });
      this.addressFormGroup.get('streetNumber').valueChanges.pipe(distinctUntilChanged(), debounceTime(400), takeUntil(this._unsubscribeAll)).subscribe(streetNumber => {
        !this.value ? this.value = {
          streetNumber
        } : this.value.streetNumber = streetNumber;
        this.value.displayAddress = this.parseDisplayAddress();
        this.propagateChange(this.value);
      });
      this.addressFormGroup.get('postalCode').valueChanges.pipe(distinctUntilChanged(), debounceTime(400), takeUntil(this._unsubscribeAll)).subscribe(postalCode => {
        !this.value ? this.value = {
          postalCode
        } : this.value.postalCode = postalCode;
        this.value.displayAddress = this.parseDisplayAddress();
        this.propagateChange(this.value);
      });
      this.addressFormGroup.get('vicinity').valueChanges.pipe(distinctUntilChanged(), debounceTime(400), takeUntil(this._unsubscribeAll)).subscribe(vicinity => {
        !this.value ? this.value = {
          vicinity
        } : this.value.vicinity = vicinity;
        this.value.displayAddress = this.parseDisplayAddress();
        this.propagateChange(this.value);
      });
      this.addressFormGroup.get('locality').valueChanges.pipe(distinctUntilChanged(), debounceTime(400), takeUntil(this._unsubscribeAll)).subscribe(locality => {
        !this.value ? this.value = {
          locality
        } : this.value.locality = locality;
        this.value.displayAddress = this.parseDisplayAddress();
        this.propagateChange(this.value);
      });
    }
    parseDisplayAddress() {
      return `${this.value?.streetName ? this.value?.streetName : ''} ${this.value?.streetNumber ? this.value?.streetNumber : ''}${this.value?.postalCode || this.value?.locality?.long ? ', ' : ''}${this.value?.postalCode ? this.value?.postalCode : ''} ${this.value?.locality?.long ? this.value?.locality?.long : ''}`;
    }
    syncAutoComplete($event) {
      if (this.germanAddress) {
        this.addressFormGroup.reset();
      }
      const germanAddress = parseGermanAddress($event);
      this.germanAddress = germanAddress;
      if (germanAddress.vicinity) {
        this.addressFormGroup.get('vicinity').patchValue(germanAddress.vicinity, {
          emitEvent: false,
          onlySelf: true
        });
      }
      if (germanAddress.streetName) {
        this.addressFormGroup.get('streetName').patchValue(germanAddress.streetName, {
          emitEvent: false,
          onlySelf: true
        });
      }
      if (germanAddress.streetNumber) {
        this.addressFormGroup.get('streetNumber').patchValue(germanAddress.streetNumber.toString(), {
          emitEvent: false,
          onlySelf: true
        });
      }
      if (germanAddress.postalCode) {
        this.addressFormGroup.get('postalCode').patchValue(germanAddress.postalCode, {
          emitEvent: false,
          onlySelf: true
        });
      }
      if (germanAddress.locality && germanAddress.locality.long) {
        this.addressFormGroup.get('locality.long').patchValue(germanAddress.locality.long, {
          emitEvent: false,
          onlySelf: true
        });
      }
      this.value = germanAddress;
      this.onGermanAddressMapped.emit(germanAddress);
    }
    writeValue(obj) {
      let shouldRecreateFG = false;
      if (obj) {
        if (!this.value && this.firstInit) {
          shouldRecreateFG = true;
        }
        this.value = obj;
        if (shouldRecreateFG) {
          this.createAddressFormGroup();
          this.firstInit = false;
        }
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {}
    static ɵfac = function MatSearchGoogleMapsAutocompleteComponent_Factory(t) {
      return new (t || MatSearchGoogleMapsAutocompleteComponent)(i0.ɵɵdirectiveInject(i1.UntypedFormBuilder));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatSearchGoogleMapsAutocompleteComponent,
      selectors: [["mat-search-google-maps-autocomplete"]],
      inputs: {
        searchBarAppearance: "searchBarAppearance",
        appearance: "appearance",
        searchAddressLabel: "searchAddressLabel",
        streetNameLabel: "streetNameLabel",
        streetNumberLabel: "streetNumberLabel",
        postalCodeLabel: "postalCodeLabel",
        localityLabel: "localityLabel",
        vicinityLabel: "vicinityLabel",
        showVicinity: "showVicinity",
        country: "country",
        placeIdOnly: "placeIdOnly",
        strictBounds: "strictBounds",
        types: "types",
        type: "type",
        readonly: "readonly",
        disableSearch: "disableSearch",
        _value: "_value",
        value: "value"
      },
      outputs: {
        onGermanAddressMapped: "onGermanAddressMapped"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MatSearchGoogleMapsAutocompleteComponent),
        multi: true
      }])],
      decls: 25,
      vars: 31,
      consts: [["fxLayout", "column"], ["fxFlex", "100", 4, "ngIf"], ["fxFlex", "", "fxLayoutGap", "10px", 3, "formGroup"], ["fxLayout", "row", "fxLayoutGap", "10px"], ["fxFlex", "80", 3, "appearance"], ["formControlName", "streetName", "matInput", "", "required", "", 3, "readonly"], ["fxFlex", "20", 3, "appearance"], ["formControlName", "streetNumber", "matInput", "", "required", "", 3, "readonly"], ["formControlName", "postalCode", "type", "number", "matInput", "", "required", "", 3, "readonly"], ["fxFlex", "auto", 3, "appearance", 4, "ngIf"], ["formGroupName", "locality", "fxFlex", "auto"], ["fxFlex", "auto", 3, "appearance"], ["formControlName", "long", "matInput", "", "required", "", 3, "readonly"], ["color", "primary", "matSuffix", ""], ["fxFlex", "100"], ["matGoogleMapsAutocomplete", "", "matInput", "", "required", "", 3, "onAutocompleteSelected", "country", "placeIdOnly", "strictBounds", "types", "type"], ["matInput", "", "formControlName", "vicinity", 3, "readonly"]],
      template: function MatSearchGoogleMapsAutocompleteComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, MatSearchGoogleMapsAutocompleteComponent_div_1_Template, 7, 11, "div", 1);
          i0.ɵɵelementStart(2, "form", 2)(3, "div", 3)(4, "mat-form-field", 4)(5, "mat-label");
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "input", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "mat-form-field", 6)(9, "mat-label");
          i0.ɵɵtext(10);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(11, "input", 7);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(12, "div", 3)(13, "mat-form-field", 6)(14, "mat-label");
          i0.ɵɵtext(15);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(16, "input", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(17, MatSearchGoogleMapsAutocompleteComponent_mat_form_field_17_Template, 4, 7, "mat-form-field", 9);
          i0.ɵɵelementStart(18, "div", 10)(19, "mat-form-field", 11)(20, "mat-label");
          i0.ɵɵtext(21);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(22, "input", 12);
          i0.ɵɵelementStart(23, "mat-icon", 13);
          i0.ɵɵtext(24, "add_location");
          i0.ɵɵelementEnd()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.disableSearch);
          i0.ɵɵadvance();
          i0.ɵɵproperty("formGroup", ctx.addressFormGroup);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("appearance", ctx.appearance)("@animate", i0.ɵɵpureFunction1(20, _c3, i0.ɵɵpureFunction0(19, _c2)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.streetNameLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("readonly", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("appearance", ctx.appearance)("@animate", i0.ɵɵpureFunction1(23, _c3, i0.ɵɵpureFunction0(22, _c2)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.streetNumberLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("readonly", ctx.readonly);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("appearance", ctx.appearance)("@animate", i0.ɵɵpureFunction1(26, _c3, i0.ɵɵpureFunction0(25, _c2)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.postalCodeLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("readonly", ctx.readonly);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showVicinity);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("appearance", ctx.appearance)("@animate", i0.ɵɵpureFunction1(29, _c3, i0.ɵɵpureFunction0(28, _c2)));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.localityLabel);
          i0.ɵɵadvance();
          i0.ɵɵproperty("readonly", ctx.readonly);
        }
      },
      dependencies: [i2.NgIf, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NumberValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.FormGroupDirective, i1.FormControlName, i1.FormGroupName, i3.DefaultLayoutDirective, i3.DefaultLayoutGapDirective, i3.DefaultFlexDirective, i4.MatInput, i5.MatFormField, i5.MatLabel, i5.MatSuffix, i6.MatIcon, MatGoogleMapsAutocompleteDirective],
      data: {
        animation: InputAnimations
      }
    });
  }
  return MatSearchGoogleMapsAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatGoogleMapsAutocompleteModule = /*#__PURE__*/(() => {
  class MatGoogleMapsAutocompleteModule {
    constructor() {}
    static forRoot(apiKey) {
      return {
        ngModule: MatGoogleMapsAutocompleteModule,
        providers: [{
          provide: ApiKeyToken,
          useValue: apiKey
        }]
      };
    }
    static ɵfac = function MatGoogleMapsAutocompleteModule_Factory(t) {
      return new (t || MatGoogleMapsAutocompleteModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatGoogleMapsAutocompleteModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, FlexLayoutModule, MatInputModule, MatIconModule]
    });
  }
  return MatGoogleMapsAutocompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of google-maps-autocomplete
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApiKeyToken, Appearance, MatGoogleMapsAutocompleteComponent, MatGoogleMapsAutocompleteDirective, MatGoogleMapsAutocompleteModule, MatSearchGoogleMapsAutocompleteComponent, MatValidateAddressDirective, ScriptLoaderService, parseGermanAddress };
